import { render, staticRenderFns } from "./BtnLiberacaoRecursos.vue?vue&type=template&id=0a3c5ebe&"
import script from "./BtnLiberacaoRecursos.vue?vue&type=script&lang=js&"
export * from "./BtnLiberacaoRecursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports